export const isBillingRecoveryRoute = (pathname: string) =>
  /^\/workspace-settings\/billing(?:-cycle)?(?:\/|$)/.test(pathname);

export const isPaymentRecoveryRoute = (pathname: string) =>
  /^\/workspace-settings\/billing(?:\/|$)/.test(pathname);
